export enum EnumPlantHistoryType {
  VisitInspection = 0,
  ProductLineItem = 1,
  IngredientLineItem = 2,
  VisitComment = 3,
}
